import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getOptionById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateVariantOption } from "..";

const EditVariantOption = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getCustomer();
        else setLoading(false);
    }, [id]);

    const getCustomer = async () => {
        try {
            const { data } = await getOptionById(id);
            setItem(data.option);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateVariantOption from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_variant' />
};

export default EditVariantOption;